import { format } from "date-fns/format";
import { formatISO } from "date-fns/formatISO";
import { formatRands } from '@/shared'
import { formatCents } from '@/shared'

export function formateDate<T extends Date|number|string|null|undefined>(date: T, displayFormat: string, fallback: string = '') {
  if (typeof date === 'number' || date instanceof Date || typeof date === 'string') {
    return format(date, displayFormat)
  }
  return fallback
}

export function formatDateAsDay(date: Date|number|string, fallback: string = '') {
  return date ? format(date, 'dd MMM yyyy') : fallback
}

export enum DateFormats {
  YearMonthDay = 'yyyy-LL-dd',
  HourMinute = 'HH:mm',
  Date = 'dd MMM yyyy',
  DayMonthYear = 'dd MMM yyyy',
  DayMonthYearFull = 'dd MMMM yyyy',
  UserFriendly = "dd MMM yyyy '@' HH:mm"
}

export const dateToIso = (date: Date|number|string) => formatISO(date)


export function dateToYMD(date: Date|number|string, fallback: string = '') {
  return date ? format(date, 'yyyy-LL-dd') : fallback
}

export function dateToDay(date: Date|number|string, fallback: string = ''){
  return date ? format(date, 'dd') : fallback
}

export function getDayOrdinalSuffix(date: Date){
  const day = date.getDate()

  if (day > 3 && day < 21) return `${day}th`; // covers 11th-19th
  switch (day % 10) {
    case 1: return `${day}st`;
    case 2: return `${day}nd`;
    case 3: return `${day}rd`;
    default: return `${day}th`;
  }
}

// Backwards compatability

export function formatToMainCurrency(value: number|undefined, config: Partial<{ currency: 'ZAR', showSymbol: boolean, maxPrecision: number }> = { }) {
  const { maxPrecision = 2 } = config

  return formatRands(value, { maxScale: maxPrecision, ...config })
}

export function formatToFractionalCurrency(value: number|undefined, config: Partial<{ currency: 'ZAR', showSymbol: boolean, maxScale: number, minScale: number }> = { }) {
  const { maxScale = 5, minScale = 2 } = config

  return formatCents(value, { maxScale, minScale, ...config })
}

export { formatNumberToPercentage } from '@/shared'
export { formatNumber } from '@/shared'
